import React from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'
import { Skeleton, Text, Flex } from 'uikit'
import { Pool } from 'state/types'
import { getBalanceNumber } from 'utils/formatBalance'
import { getAddress } from 'utils/addressHelpers'
import { formatValue } from 'utils'
import Balance from 'components/Balance'

const FCard = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  border-radius: 12px 12px 0px 0px;
  font-weight: bold;
  line-height: 22px;
  color: #ffffff;
  font-size: 15px;
  padding: 14px 16px;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 14px 21px;
  }
`

const Basic = styled.div`
  display: flex;
  grid-column: span 8;

  ${({ theme }) => theme.mediaQueries.sm} {
    grid-column: span 4;
  }
`

const No = styled.span`
  display: none;

  ${({ theme }) => theme.mediaQueries.sm} {
    display: flex;
    width: 20px;
  }
`

const PoolImg = styled.img`
  height: 22px;
  margin-right: 4px;
`

const Symbol = styled.div`
  display: none;

  ${({ theme }) => theme.mediaQueries.sm} {
    display: flex;
    grid-column: span 1;
  }
`

const APR = styled(Flex)`
  grid-column: span 5;

  ${({ theme }) => theme.mediaQueries.sm} {
    grid-column: span 1;
  }
`

const BalanceAPR = styled(Balance)`
  display: block;
  font-size: 15px;
  font-weight: bold;
  grid-column: span 5;

  ${({ theme }) => theme.mediaQueries.sm} {
    grid-column: span 1;
  }
`

const TotalStaked = styled(Text)`
  display: flex;
  justify-content: end;
  grid-column: span 3;

  ${({ theme }) => theme.mediaQueries.sm} {
    grid-column: span 2;
  }
`

interface FarmItemProps {
  pool: Pool
  no?: number
}

const PoolItem: React.FC<FarmItemProps> = ({ pool, no }) => {
  const { t } = useTranslation()

  const symbol = `${pool.stakingToken.symbol}/DMD`

  const totalStaked = getBalanceNumber(new BigNumber(pool.totalStaked), pool.stakingToken.decimals)

  return (
    <FCard>
      <Basic>
        <No>{no}</No>
        <PoolImg
          src={`/images/tokens/${getAddress(pool.stakingToken.address)}.png`}
          alt={`${getAddress(pool.stakingToken.address)}.png`}
        />
        <span>
          {t('Earn')} DMD / {t('Stake')} {pool.stakingToken.symbol}
        </span>
      </Basic>
      <Symbol>{symbol}</Symbol>
      {pool.apr ? (
        <BalanceAPR textAlign="right" decimals={0} value={pool.apr} unit="%" />
      ) : (
        <APR justifyContent="end">
          <Skeleton height={22} width={60} />
        </APR>
      )}
      {totalStaked && !Number.isNaN(totalStaked) ? (
        <TotalStaked textAlign="right">
          {formatValue(totalStaked)} {pool.stakingToken.symbol}
        </TotalStaked>
      ) : (
        <TotalStaked>
          <Skeleton height={22} width={60} />
        </TotalStaked>
      )}
    </FCard>
  )
}

export default PoolItem
